import styled from '@emotion/styled'
import { motion } from 'framer-motion'

export const Box = styled(motion.div)`
  overflow: hidden;
`
